<template>
  <div class="collect-matchs-detail">
    <div class="top-rich-text">
      <div class="rich-text"></div>
      <div class="btns">
        <router-link :to="'/activities/enroll?id='+id+'&plate=2'"><el-button size="medium">作品征集报名</el-button></router-link>
        <el-button size="medium">分享</el-button>
      </div>
    </div>
    <div class="select-tit">
      <span class="active">全部作品</span> |
      <span>获奖作品</span>
    </div>
    <div class="clearfix">
      <div class="work-card-one">
        <router-link to="/worksdetail" class="img-f">
          <img :src="require('@/assets/images/card_img_01.jpg')" alt="">
        </router-link>
        <div class="card-infoes">
          <router-link to="/worksdetail" class="card-tit over-ellipsis">作品名称作品名称作品名称作品名称作品名称</router-link>
          <div class="card-tags over-ellipsis">动画 / 标签1 / 标签2 / 标签3标签3标签3标签3标签3</div>
          <div class="card-czs">
            <i class="icon zan"></i><span class="much">66</span>
            <i class="icon cai"></i><span class="much">66</span>
            <i class="icon pinglun"></i><span class="much">66</span>
            <i class="icon zhuanfa"></i>
          </div>
        </div>
        <div class="auther">
          <router-link to="/home" class="avatar-f">
            <img :src="require('@/assets/images/user_avatar.jpg')" alt="">
          </router-link>
          <router-link to="/home" class="user-name over-ellipsis">人人动画人人动画人人动画</router-link>
          <div class="date">1天前</div>
        </div>
      </div>
      <div class="work-card-one">
        <router-link to="/worksdetail" class="img-f">
          <img :src="require('@/assets/images/card_img_01.jpg')" alt="">
        </router-link>
        <div class="card-infoes">
          <router-link to="/worksdetail" class="card-tit over-ellipsis">作品名称</router-link>
          <div class="card-tags over-ellipsis">动画 / 标签1 / 标签2 / 标签3</div>
          <div class="card-czs">
            <i class="icon zan"></i><span class="much">66</span>
            <i class="icon cai"></i><span class="much">66</span>
            <i class="icon pinglun"></i><span class="much">66</span>
            <i class="icon zhuanfa"></i>
          </div>
        </div>
        <div class="auther">
          <router-link to="/home" class="avatar-f">
            <img :src="require('@/assets/images/user_avatar.jpg')" alt="">
          </router-link>
          <router-link to="/home" class="user-name over-ellipsis">人人动画</router-link>
          <div class="date">1天前</div>
        </div>
      </div>
      <div class="work-card-one">
        <router-link to="/worksdetail" class="img-f">
          <img :src="require('@/assets/images/card_img_01.jpg')" alt="">
        </router-link>
        <div class="card-infoes">
          <router-link to="/worksdetail" class="card-tit over-ellipsis">作品名称作品名称作品名称作品名称作品名称</router-link>
          <div class="card-tags over-ellipsis">动画 / 标签1 / 标签2 / 标签3标签3标签3标签3标签3</div>
          <div class="card-czs">
            <i class="icon zan"></i><span class="much">66</span>
            <i class="icon cai"></i><span class="much">66</span>
            <i class="icon pinglun"></i><span class="much">66</span>
            <i class="icon zhuanfa"></i>
          </div>
        </div>
        <div class="auther">
          <router-link to="/home" class="avatar-f">
            <img :src="require('@/assets/images/user_avatar.jpg')" alt="">
          </router-link>
          <router-link to="/home" class="user-name over-ellipsis">人人动画</router-link>
          <div class="date">1天前</div>
        </div>
      </div>
      <div class="work-card-one">
        <router-link to="/worksdetail" class="img-f">
          <img :src="require('@/assets/images/card_img_01.jpg')" alt="">
        </router-link>
        <div class="card-infoes">
          <router-link to="/worksdetail" class="card-tit over-ellipsis">作品名称</router-link>
          <div class="card-tags over-ellipsis">动画 / 标签1 / 标签2 / 标签3</div>
          <div class="card-czs">
            <i class="icon zan"></i><span class="much">66</span>
            <i class="icon cai"></i><span class="much">66</span>
            <i class="icon pinglun"></i><span class="much">66</span>
            <i class="icon zhuanfa"></i>
          </div>
        </div>
        <div class="auther">
          <router-link to="/home" class="avatar-f">
            <img :src="require('@/assets/images/user_avatar.jpg')" alt="">
          </router-link>
          <router-link to="/home" class="user-name over-ellipsis">人人动画</router-link>
          <div class="date">1天前</div>
        </div>
      </div>
      <div class="work-card-one">
        <router-link to="/worksdetail" class="img-f">
          <img :src="require('@/assets/images/card_img_01.jpg')" alt="">
        </router-link>
        <div class="card-infoes">
          <router-link to="/worksdetail" class="card-tit over-ellipsis">作品名称作品名称作品名称作品名称作品名称</router-link>
          <div class="card-tags over-ellipsis">动画 / 标签1 / 标签2 / 标签3标签3标签3标签3标签3</div>
          <div class="card-czs">
            <i class="icon zan"></i><span class="much">66</span>
            <i class="icon cai"></i><span class="much">66</span>
            <i class="icon pinglun"></i><span class="much">66</span>
            <i class="icon zhuanfa"></i>
          </div>
        </div>
        <div class="auther">
          <router-link to="/home" class="avatar-f">
            <img :src="require('@/assets/images/user_avatar.jpg')" alt="">
          </router-link>
          <router-link to="/home" class="user-name over-ellipsis">人人动画</router-link>
          <div class="date">1天前</div>
        </div>
      </div>
      <div class="work-card-one">
        <router-link to="/worksdetail" class="img-f">
          <img :src="require('@/assets/images/card_img_01.jpg')" alt="">
        </router-link>
        <div class="card-infoes">
          <router-link to="/worksdetail" class="card-tit over-ellipsis">作品名称</router-link>
          <div class="card-tags over-ellipsis">动画 / 标签1 / 标签2 / 标签3</div>
          <div class="card-czs">
            <i class="icon zan"></i><span class="much">66</span>
            <i class="icon cai"></i><span class="much">66</span>
            <i class="icon pinglun"></i><span class="much">66</span>
            <i class="icon zhuanfa"></i>
          </div>
        </div>
        <div class="auther">
          <router-link to="/home" class="avatar-f">
            <img :src="require('@/assets/images/user_avatar.jpg')" alt="">
          </router-link>
          <router-link to="/home" class="user-name over-ellipsis">人人动画</router-link>
          <div class="date">1天前</div>
        </div>
      </div>
      <div class="work-card-one">
        <router-link to="/worksdetail" class="img-f">
          <img :src="require('@/assets/images/card_img_01.jpg')" alt="">
        </router-link>
        <div class="card-infoes">
          <router-link to="/worksdetail" class="card-tit over-ellipsis">作品名称作品名称作品名称作品名称作品名称</router-link>
          <div class="card-tags over-ellipsis">动画 / 标签1 / 标签2 / 标签3标签3标签3标签3标签3</div>
          <div class="card-czs">
            <i class="icon zan"></i><span class="much">66</span>
            <i class="icon cai"></i><span class="much">66</span>
            <i class="icon pinglun"></i><span class="much">66</span>
            <i class="icon zhuanfa"></i>
          </div>
        </div>
        <div class="auther">
          <router-link to="/home" class="avatar-f">
            <img :src="require('@/assets/images/user_avatar.jpg')" alt="">
          </router-link>
          <router-link to="/home" class="user-name over-ellipsis">人人动画</router-link>
          <div class="date">1天前</div>
        </div>
      </div>
      <div class="work-card-one">
        <router-link to="/worksdetail" class="img-f">
          <img :src="require('@/assets/images/card_img_01.jpg')" alt="">
        </router-link>
        <div class="card-infoes">
          <router-link to="/worksdetail" class="card-tit over-ellipsis">作品名称</router-link>
          <div class="card-tags over-ellipsis">动画 / 标签1 / 标签2 / 标签3</div>
          <div class="card-czs">
            <i class="icon zan"></i><span class="much">66</span>
            <i class="icon cai"></i><span class="much">66</span>
            <i class="icon pinglun"></i><span class="much">66</span>
            <i class="icon zhuanfa"></i>
          </div>
        </div>
        <div class="auther">
          <router-link to="/home" class="avatar-f">
            <img :src="require('@/assets/images/user_avatar.jpg')" alt="">
          </router-link>
          <router-link to="/home" class="user-name over-ellipsis">人人动画</router-link>
          <div class="date">1天前</div>
        </div>
      </div>
      <div class="work-card-one">
        <router-link to="/worksdetail" class="img-f">
          <img :src="require('@/assets/images/card_img_01.jpg')" alt="">
        </router-link>
        <div class="card-infoes">
          <router-link to="/worksdetail" class="card-tit over-ellipsis">作品名称作品名称作品名称作品名称作品名称</router-link>
          <div class="card-tags over-ellipsis">动画 / 标签1 / 标签2 / 标签3标签3标签3标签3标签3</div>
          <div class="card-czs">
            <i class="icon zan"></i><span class="much">66</span>
            <i class="icon cai"></i><span class="much">66</span>
            <i class="icon pinglun"></i><span class="much">66</span>
            <i class="icon zhuanfa"></i>
          </div>
        </div>
        <div class="auther">
          <router-link to="/home" class="avatar-f">
            <img :src="require('@/assets/images/user_avatar.jpg')" alt="">
          </router-link>
          <router-link to="/home" class="user-name over-ellipsis">人人动画</router-link>
          <div class="date">1天前</div>
        </div>
      </div>
      <div class="work-card-one">
        <router-link to="/worksdetail" class="img-f">
          <img :src="require('@/assets/images/card_img_01.jpg')" alt="">
        </router-link>
        <div class="card-infoes">
          <router-link to="/worksdetail" class="card-tit over-ellipsis">作品名称</router-link>
          <div class="card-tags over-ellipsis">动画 / 标签1 / 标签2 / 标签3</div>
          <div class="card-czs">
            <i class="icon zan"></i><span class="much">66</span>
            <i class="icon cai"></i><span class="much">66</span>
            <i class="icon pinglun"></i><span class="much">66</span>
            <i class="icon zhuanfa"></i>
          </div>
        </div>
        <div class="auther">
          <router-link to="/home" class="avatar-f">
            <img :src="require('@/assets/images/user_avatar.jpg')" alt="">
          </router-link>
          <router-link to="/home" class="user-name over-ellipsis">人人动画</router-link>
          <div class="date">1天前</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
export default {
  components: {

  },
  data () {
    return {

    }
  }
}
</script>

<style scoped lang="less">
//@import "../../../assets/less/stylePublic.less";
</style>
